export default "__VITE_ASSET__859942bb__"